import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { SUPPORTERS_IDS_STREAM } from '../../../streams';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getUsersByIds } from '@wix/da-shared-react/pkg/redux/users/selectors';

const streamId = SUPPORTERS_IDS_STREAM;

export default connect((state: AppState) => {
  const deviants = getUsersByIds(
    state,
    streamSelectors.getItems(state, streamId)
  );
  const hasMore = streamSelectors.hasMore(state, streamId);
  const isFetching = streamSelectors.isFetching(state, streamId);
  return {
    profileOwnerUser: getProfileOwnerUser(state),
    deviants,
    hasMore,
    isFetching,
    isOwner: isCurrentUserProfileOwner(state),
    isEmpty: !deviants || !deviants.length,
    canSeeAll: streamSelectors.getStreamParam(state, streamId, 'canSeeAll'),
  };
});
